module.exports = __webpack_public_path__ + "static/media/iot3.30f88ad4.jpg";